import { ArrowDown, Sparkles } from "lucide-react";
import { ASSETS, SITE } from "@/lib/site";

export const Hero = () => {
  const scrollTo = (id) => document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });

  return (
    <section
      id="hero"
      data-testid="hero-section"
      className="relative min-h-[100vh] w-full overflow-hidden flex items-center grain"
    >
      <div
        className="absolute inset-0 bg-cover bg-center"
        style={{ backgroundImage: `url(${ASSETS.hero})` }}
        aria-hidden
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/55 to-black" aria-hidden />
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_center,_transparent_0%,_rgba(5,5,5,0.85)_70%)]" aria-hidden />

      <div className="relative z-10 max-w-7xl mx-auto px-6 lg:px-10 w-full py-32 lg:py-40">
        <div className="max-w-4xl">
          <div className="fade-up inline-flex items-center gap-2 px-4 py-2 rounded-full border border-[#2DD4BF]/30 bg-[#2DD4BF]/5 mb-8">
            <Sparkles size={14} className="text-[#2DD4BF]" />
            <span className="text-xs tracking-[0.25em] uppercase text-[#2DD4BF]">
              Bangalore · India · Established for the World
            </span>
          </div>

          <h1
            data-testid="hero-title"
            className="fade-up delay-1 font-serif text-5xl sm:text-6xl md:text-7xl lg:text-[88px] leading-[1.02] tracking-tight text-white"
          >
            <span className="block">Cinema, told</span>
            <span className="block italic text-gradient-aum">in six tongues.</span>
            <span className="block">Shot as one.</span>
          </h1>

          <p
            data-testid="hero-subtitle"
            className="fade-up delay-2 mt-8 max-w-2xl text-lg md:text-xl text-slate-300 leading-relaxed"
          >
            {SITE.name} is the first production house from Bangalore to shoot an English feature with
            native English lip‑sync simultaneously alongside Kannada — extending into Hindi, Telugu,
            Tamil and Malayalam. South Indian storytelling, built for Pan‑India and Asia.
          </p>

          <div className="fade-up delay-3 mt-12 flex flex-wrap items-center gap-4">
            <button
              data-testid="hero-cta-projects"
              onClick={() => scrollTo("zero-to-one")}
              className="btn-aum"
            >
              Explore Zero to One
            </button>
            <button
              data-testid="hero-cta-portfolio"
              onClick={() => scrollTo("portfolio")}
              className="btn-ghost"
            >
              Share Your Portfolio
            </button>
          </div>

          <div className="fade-up delay-4 mt-16 grid grid-cols-3 gap-6 max-w-2xl">
            {[
              { k: "12+", v: "Years in Bollywood" },
              { k: "7", v: "Films as AD / Associate" },
              { k: "6", v: "Languages, one shoot" },
            ].map((s) => (
              <div key={s.v} className="glass-card rounded-xl px-4 py-5">
                <div className="font-serif text-3xl md:text-4xl text-gradient-gold">{s.k}</div>
                <div className="text-xs tracking-widest uppercase text-slate-400 mt-2">{s.v}</div>
              </div>
            ))}
          </div>
        </div>
      </div>

      <button
        onClick={() => scrollTo("about")}
        className="absolute bottom-8 left-1/2 -translate-x-1/2 z-10 text-slate-400 hover:text-[#2DD4BF] transition-colors flex flex-col items-center gap-2"
        data-testid="hero-scroll-cue"
      >
        <span className="text-[10px] tracking-[0.3em] uppercase">Scroll</span>
        <ArrowDown size={16} className="animate-bounce" />
      </button>
    </section>
  );
};
